import { useId, type ReactElement, type ReactNode } from 'react';
import type { Role } from '@chatapp-inbox/shared';
import styles from './forms.module.css';

const OPTIONS: { value: Role; title: string; description: string }[] = [
  {
    value: 'agent',
    title: 'Atendente',
    description: 'Atende as próprias conversas e as não atribuídas. Não acessa a administração.',
  },
  {
    value: 'admin',
    title: 'Administrador',
    description: 'Vê e atribui todas as conversas, gerencia usuários e a conexão do WhatsApp.',
  },
];

/** Escolha do papel: duas opções que se explicam (um seletor esconderia a diferença). */
export function RoleField({
  value,
  onChange,
  disabled = false,
  note,
}: {
  value: Role;
  onChange: (role: Role) => void;
  disabled?: boolean;
  /** Explicação que acompanha o grupo (por exemplo, por que está travado). */
  note?: ReactNode;
}): ReactElement {
  const uid = useId();
  const noteId = `${uid}-note`;
  return (
    <fieldset className={styles.fieldset} aria-describedby={note ? noteId : undefined}>
      <legend className={styles.legend}>Papel</legend>
      {note && (
        <p id={noteId} className={styles.hint}>
          {note}
        </p>
      )}
      {OPTIONS.map((option) => (
        <label key={option.value} className={styles.radio}>
          <input
            type="radio"
            name={`${uid}-role`}
            value={option.value}
            checked={value === option.value}
            disabled={disabled}
            onChange={() => onChange(option.value)}
          />
          <span className={styles.radioTitle}>{option.title}</span>
          <span className={styles.radioHint}>{option.description}</span>
        </label>
      ))}
    </fieldset>
  );
}
